import { render } from "./Home.vue?vue&type=template&id=3e6aa466"
const script = {}
script.render = render

export default script